export const UPDATE_PRODUCT_CART = 'UPDATE_PRODUCT_CART';

export const updateProductCart = (product) => {
  return {
    type: UPDATE_PRODUCT_CART,
    payload: product,
  };
};
